<template>
  <div class="d-inline-block">
    <a
      v-if="!editMode"
      href="#"
      @click.stop.prevent="create"
    >
      <font-awesome-icon
        icon="plus-circle"
        class="mr-1"
      />New folder
    </a>
    <div v-else>
      <input
        ref="input"
        v-model="name"
        type="text"
        class="form-control"
        @keyup.enter="onSubmit"
      >
      <div class="text-right">
        <a
          href="#"
          class="text-muted"
          @click.prevent="editMode = false"
        >Cancel</a>
        <span class="mx-2">|</span>
        <a
          href="#"
          @click.prevent="onSubmit"
        >Save</a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'FolderCreate',
  data() {
    return {
      name: '',
      editMode: false,
    };
  },
  methods: {
    create() {
      this.editMode = true;
      this.name = '';
      this.$nextTick().then(() => {
        this.$refs.input.focus();
      });
    },
    onSubmit() {
      if (this.name === '') {
        this.editMode = false;
        return;
      }
      this.$store
        .dispatch('folders/newItem', {
          name: this.name,
        })
        .then((r) => {
          this.editMode = false;
          this.$store.dispatch('folders/getAll');
          this.name = '';
          this.$router.push(`/collateral/folder/${r.data.pk}`);
        });
    },
  },
};
</script>

<style lang="scss" scoped>
</style>
